<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <!-- status -->
        <td class="px-1 py-4">
          <div class="flex items-center">
            <div
              class="h-2.5 w-2.5 rounded-full me-2"
            ></div>
            {{ row["id"] }}
          </div>
        </td>

        <!-- foto, nome e função -->
        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <!-- foto -->
          <img
            class="w-10 h-10 rounded-full"
            :src="defaultImg"
            alt="Jese image"
          />

          <!-- nome e função -->
          <div class="ps-3">
            <div class="text-base font-semibold">
              {{ row["nome"] }}
            </div>

            <div class="font-normal text-gray-500">
              {{ row["especialidade"] }}
            </div>
          </div>
        </th>

        <!-- tipo -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <!-- nome do documento e tipo -->
          <div>
            <div
              :title="row['docOriginalName']"
              class="text-base font-semibold"
            >
              {{ row["especialidade"] }}
            </div>

            <!-- <div class="font-normal text-gray-500 lowercase">
              {{
                row["key"]?.length > 20
                  ? row["key"].slice(0, 20).concat("...")
                  : row["key"]
              }}
            </div> -->
          </div>
        </td>

        <!-- vencimento -->
        <td class="px-6 py-4">
          <div class="flex items-center">
            <div
              class="h-2.5 w-2.5 rounded-full bg-green-500 me-2"
            ></div>
            {{ setCity(row["cidade_id"]) }}
          </div>
        </td>

        <!-- ações -->
        <td class="px-6 py-4">
          <div class="flex justify-center font-medium">
            
            <!-- alterar dados -->
            <a
              title="Editar registro"
              class="text-gray-400 mr-1 hover:underline cursor-pointer"
            >
              <component :is="PhNotePencil" class="h-6 w-6" />
            </a>

            <!-- relatório -->
            <a
              title="Gerar relatório"
              class="text-gray-400 mr-1 hover:underline cursor-pointer"
            >
              <component :is="PhFileDoc" class="h-6 w-6" />
            </a>

            <!-- remover médico -->
            <a
              title="Remover registro"
              class="text-gray-400 mr-1 hover:underline cursor-pointer"
            >
              <component :is="PhTrash" class="h-6 w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup> ;
import {
  PhFileDoc,
  PhNotePencil,
  PhTrash,
} from "@phosphor-icons/vue";
import { defineProps, onBeforeMount } from "vue";
import { dataAso } from "../../store";
import AsosService from "../../service/asos.service";

const defaultImg = require("@/assets/logo/icon.png");
const props = defineProps({
  data: [Object, Array],
});

function setCity(cityId) {
  const city = dataAso.getters.getCities.find(c => c.id === cityId);
  return city ? city.nome : 'Não informado';
}

</script>
